import Map from 'ol/Map';
import View from 'ol/View';
import { register } from 'ol/proj/proj4';
import { get } from 'ol/proj';
import { layerCanvasFilter } from './canvasFilter';
export class CloneMap {
    sourceMap;
    listenerChangeResolution;
    listenerChangeCenter;
    proj4;
    printSourceCallback;
    map = null;
    targetMapDiv = null;
    constructor(sourceMap, listenerChangeResolution, listenerChangeCenter, proj4, printSourceCallback) {
        this.sourceMap = sourceMap;
        this.listenerChangeResolution = listenerChangeResolution;
        this.listenerChangeCenter = listenerChangeCenter;
        this.proj4 = proj4;
        this.printSourceCallback = printSourceCallback;
        this.sourceMap || console.warn('CloneMap: missing source!');
        this.proj4 && register(this.proj4);
    }
    clone(targetMapDiv, pixelRatio) {
        this.destroyMap();
        this.targetMapDiv = targetMapDiv;
        /**
         * printSource - zmena source vrstvy na zaklade jeji konfigurace a parametru "printSource"
         * bude obsahovat parametr 'type' urcujici o jakou alternativu (viz vyse) se jedna
         */
        const clonedLayers = this.sourceMap
            .getLayers()
            .getArray()
            .map((overlay) => {
            const layerToClone = overlay;
            const clonedLayer = new layerToClone.constructor({
                ...overlay.getProperties(),
                map: undefined,
            });
            // poplatne datove strukture SBX1:_viewer_config_
            const filter = layerToClone._viewer_config_?.filter;
            // clone styles
            clonedLayer.setStyle?.(layerToClone.getStyle());
            clonedLayer.setStyleFunction?.(layerToClone.getStyleFunction());
            // canvas filter
            filter && layerCanvasFilter(clonedLayer, filter);
            return clonedLayer;
        });
        const layers = this.printSourceCallback ? this.printSourceCallback(clonedLayers) : clonedLayers;
        const clonedOverlays = this.sourceMap
            .getOverlays()
            .getArray()
            .map((overlay) => {
            const layerToClone = overlay;
            const clonedLayer = new layerToClone.constructor({
                ...overlay.getProperties(),
                map: undefined,
            });
            // clone styles
            clonedLayer.setStyle?.(layerToClone.getStyle());
            clonedLayer.setStyleFunction?.(layerToClone.getStyleFunction());
            return clonedLayer;
        });
        const overlays = this.printSourceCallback
            ? this.printSourceCallback(clonedOverlays)
            : clonedOverlays;
        this.map = new Map({
            target: targetMapDiv,
            pixelRatio,
            view: this.cloneView(),
            layers, // only "managed" layers
            controls: [],
            overlays,
        });
        this.listenerChangeResolution &&
            this.map.getView().on('change:resolution', this.listenerChangeResolution);
        this.listenerChangeCenter && this.map.getView().on('change:center', this.listenerChangeCenter);
        // pouzito v MapOverviewPreview
        // @ts-ignore
        this.map.getView().getClone = () => {
            return this.cloneView();
        };
        return this.map;
    }
    /**
     * Musi vzniknout nova instance projection, aby fungoval MapScaleLine
     */
    cloneView() {
        const sv = this.sourceMap.getView(), minZoom = sv.getMinZoom(), maxZoom = sv.getMaxZoom();
        return new View({
            center: sv.getCenter(),
            zoom: sv.getZoom(),
            minResolution: maxZoom ? undefined : sv.getMinResolution(),
            maxResolution: minZoom ? undefined : sv.getMaxResolution(),
            minZoom,
            maxZoom,
            resolutions: sv.getResolutions(),
            projection: get(sv.getProjection().getCode()),
            enableRotation: false,
        });
    }
    destroyMap() {
        if (this.map) {
            this.listenerChangeResolution &&
                this.map.getView().un('change:resolution', this.listenerChangeResolution);
            this.listenerChangeCenter &&
                this.map.getView().un('change:center', this.listenerChangeCenter);
            this.map.setTarget(undefined);
            this.map = null;
        }
    }
    // TODO: predelat na fit() || animate()
    setResolution(resolution, center) {
        this.map && this.map.getView().setResolution(resolution);
        this.map && center && this.map.getView().setCenter(center);
    }
    refresh() {
        this.map?.updateSize();
    }
    isTainted(targetMapDiv) {
        targetMapDiv && (this.targetMapDiv = targetMapDiv);
        if (this.targetMapDiv) {
            try {
                const canvas = this.targetMapDiv.getElementsByTagName('canvas')[0];
                if (!canvas)
                    return true;
                const ctx = canvas.getContext('2d');
                if (!ctx)
                    return true;
                ctx.getImageData(0, 0, 1, 1);
            }
            catch (e) {
                console.error('[isTainted]', e);
                return true;
            }
        }
        return false;
    }
}
//# sourceMappingURL=CloneMap.js.map